const URLNewsletter = process.env.REACT_APP_NEWSLETTER;

class NewsletterService {
  async sendNewsletter(email) {
    return fetch(URLNewsletter, {
      method: 'POST',
      body: JSON.stringify({ email: email }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => (res.ok ? true : Promise.reject(res)));
  }
}

export default new NewsletterService();



// WEBPACK FOOTER //
// ./src/services/Newsletter.service.js